import { useState } from 'react';
import { Modal } from '@wapharma/design-system';
import { userRoleLabelFr } from '../constants/userRoleDisplay';
import { rolePersonaDataUri } from '../lib/rolePersonaAvatar';
import styles from './UserRolePill.module.css';

/** Notionists face + label. Color stays for Accès coverage, not roles.
 *  `faceShape="tile"` = soft square (role identity); default circle.
 */
export function UserRolePill({
  role,
  faceShape = 'circle',
}: {
  role: string;
  faceShape?: 'circle' | 'tile';
}) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const label = userRoleLabelFr(role);
  const src = rolePersonaDataUri(role);

  return (
    <>
      <span className={styles.persona} title={label}>
        <button
          type="button"
          className={styles.faceBtn}
          aria-label={`Aperçu — ${label}`}
          onClick={(e) => {
            e.stopPropagation();
            setPreviewOpen(true);
          }}
        >
          <img
            className={faceShape === 'tile' ? `${styles.face} ${styles.faceTile}` : styles.face}
            src={src}
            alt=""
            width={32}
            height={32}
            decoding="async"
          />
        </button>
        <span className={styles.label}>{label}</span>
      </span>
      <Modal opened={previewOpen} onClose={() => setPreviewOpen(false)} title={label} size="sm">
        <div className={styles.previewWrap}>
          <img
            className={
              faceShape === 'tile'
                ? `${styles.previewFace} ${styles.previewFaceTile}`
                : styles.previewFace
            }
            src={src}
            alt=""
            width={220}
            height={220}
          />
        </div>
      </Modal>
    </>
  );
}
